import { useNavigate } from "react-router-dom";

import { useConfiguration } from "../../api/configurations/use-configuration";
import { AI_ROUTES } from "../../routes/routes";

import { TestPilotButton } from "./TestPilotButton";

export const TestIdeasAiButton = () => {
  const navigate = useNavigate();

  const hasAccess = useConfiguration<boolean>("enable_ai")?.value;

  if (!hasAccess) {
    return null;
  }

  return (
    <TestPilotButton
      onClick={() => navigate(AI_ROUTES.ScreenshotRecommendations)}
    />
  );
};
